'use client'

import { useEECEvents } from 'analytics/hooks/useEECEvents/useEECEvents'
import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { ClientLink, type ClientLinkProps } from 'utils/link/client'

import type { PdpLinkProps } from '../types'
import { getProductUrl } from '../utils/getProductUrl/getProductUrl'

export function PdpClientLink({
	product,
	colorId,
	lookId,
	sizeId,
	children,
	linkProps,
	location,
	skipTabKey,
}: PdpLinkProps): React.ReactNode {
	const { enabled } = useFeatureFlag(featureFlagKeys.GenesisPdp)
	const { sendSelectItem } = useEECEvents()

	const productUrl = getProductUrl({ product, colorId, lookId, enabled })

	const props: ClientLinkProps = {
		...linkProps,
		children,
		href: productUrl,
		isLocalizedPath: true,
		withLegacyLocale: !enabled ? true : undefined,
		prefetch: false,
		onClick: () => {
			sendSelectItem({
				item: {
					colorId,
					lookId,
					sizeId,
					productId: product.id,
					quantity: 1,
				},
				location,
			})
		},
		skipTabKey,
	}

	return <ClientLink {...props}>{children}</ClientLink>
}
